export default __webpack_public_path__ + "static/image-interactive-price-card-a6aebfa86a989ffb485d5e5ac406f195.png";